export function validate(value) {
  return (
    typeof value?.name === 'string' && /tx_card_field_options/.test(value.name)
  )
}
